// @charset "utf-8"
import Vue from 'vue'
import Vuex from 'vuex'

import userInfo from './modules/userInfo'
import logo from './modules/logo'
import myStrategy from './modules/myStrategy'

Vue.use(Vuex)
const state = {
}
const mutations = {
}
const actions = {
}
const getters = {
}
const modules = {
    userInfo,
    logo,
    myStrategy
}
export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules
})



// WEBPACK FOOTER //
// ./src/store/index.js